import { render } from "./ThePatientDocumentList.vue?vue&type=template&id=46e676d3&ts=true"
import script from "./ThePatientDocumentList.vue?vue&type=script&lang=ts"
export * from "./ThePatientDocumentList.vue?vue&type=script&lang=ts"

import "./ThePatientDocumentList.vue?vue&type=style&index=0&id=46e676d3&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__